import GravityV3Adapter, { baseUrl as gravityV3BaseUrl } from 'teacher-ui-client/adapters/gravity/v3-adapter'
import { Product } from 'teacher-ui-client/utils/products'
import { adapterHostAndNamespace, join } from 'teacher-ui-client/utils/uri'

const url = join(gravityV3BaseUrl, 'teacher-ui/assignments', Product.REX)
export const { host, namespace } = adapterHostAndNamespace(url)
export const baseUrl = url.href

export default class ReadAloudReviewAdapter extends GravityV3Adapter {
  namespace = namespace
}
